export const checkSessionStorageExists = (storageName: string) => {
  if (typeof window !== 'undefined') {
    return window.sessionStorage.hasOwnProperty(storageName)
  }

  return false
}
